<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 18 14"
  >
    <path
      id="Path_8598"
      class="folder-stroke"
      data-name="Path 8598"
      d="M17,2H8.655L6.97.3A1,1,0,0,0,6.259,0H1A1,1,0,0,0,0,1V13a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V3A1,1,0,0,0,17,2ZM16,12H2V4H16Z"
      fill="#405866"
    />
  </svg>
</template>

<script>
export default {
  name: 'FolderIcon',
};
</script>

<style scoped lang="scss">
.folder-stroke {
  fill: var(--feature-color, main.$npGray);
}
</style>
